// extracted by mini-css-extract-plugin
export var arrowDownIcon = "styles-module--arrowDownIcon--cbffa";
export var arrowUpIcon = "styles-module--arrowUpIcon--69749";
export var link = "styles-module--link--6a5de";
export var linkIcon = "styles-module--linkIcon--5d7c8";
export var linkItem = "styles-module--linkItem--7d3ba";
export var linksList = "styles-module--linksList--f1433";
export var open = "styles-module--open--bb82a";
export var other = "styles-module--other--98e76";